import { conceptIDs } from "../../../constants/constant";
import { FormValues, SchedulerConfig } from "../../../Interface/scheduler/form";
import { BookingApiCallHandler } from "../components/Helper/BookingApiCallHandler";

interface UseJukPaymentHandler {
  formValues: FormValues;
  formConfig: SchedulerConfig;
  setTechnicalModalOpen: (open: boolean) => void;
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
  bookingWrapper?: boolean;
}

export const useJukPaymentScenario = () => {
  const handleJukPaymentScenario = async ({
    formValues,
    formConfig,
    setTechnicalModalOpen,
    setFormValues,
    bookingWrapper,
  }: UseJukPaymentHandler) => {
    if (!formValues || !formConfig) {
      return;
    }
    if (
      !formValues?.paymentEnabled ||
      formConfig?.conceptid !== conceptIDs?.JUK_CONCEPT_ID
    ) {
      return;
    }

    try {
      // Make booking API call for JUK payment scenario
      let res;
      if (formValues?.scheduleId && !bookingWrapper) {
        res = await BookingApiCallHandler(
          formConfig,
          formValues,
          setTechnicalModalOpen,
        );
      } else if (formValues?.scheduleId && bookingWrapper) {
        res = await BookingApiCallHandler(
          formConfig,
          formValues,
          setTechnicalModalOpen,
          {},
          false,
          {
            bookingWrapper: true,
            current: 2,
            total: 4,
            upSellEnabled: false,
          },
        );
      }
      // Update form values with the work order ID from the response
      setFormValues((prevValues) => ({
        ...prevValues,
        jkcode: res?.workOrderId ?? "",
      }));
    } catch (error) {
      console.error("Error in JUK Payment Scenario:", error);
      setTechnicalModalOpen(true);
    }
  };

  return handleJukPaymentScenario;
};
